export class EmployeeMhs {
    firstName: string;
    lastName: string;
    employer : string;
    division: string;
    ssn: string;
    birthDate: string;
    hireDate: string;
    position: string;
    earnings: string;
    signatureDateTime: string;
}